import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { displayPersonaName, personaColor, personInitials } from '../../helpers/personaUtils';

const useStyles = makeStyles({
    persona: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        minWidth: 0,
    },
    initials: {
        width: '26px',
        height: '26px',
        borderRadius: tokens.borderRadiusCircular,
        display: 'grid',
        placeItems: 'center',
        fontSize: '10.5px',
        fontWeight: tokens.fontWeightBold,
        color: '#fff',
        flex: 'none',
    },
    name: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});

interface CreatedByPersonaProps {
    name?: string | null;
    className?: string;
}

/** Round avatar with deterministic color + name, for the "Created By" column. */
const CreatedByPersona = ({ name, className }: CreatedByPersonaProps) => {
    const styles = useStyles();

    if (!name) {
        return <span>--</span>;
    }

    return (
        <span className={mergeClasses(styles.persona, className)}>
            <span className={styles.initials} style={{ backgroundColor: personaColor(name) }} aria-hidden>
                {personInitials(name)}
            </span>
            <span className={styles.name}>{displayPersonaName(name)}</span>
        </span>
    );
};

export default CreatedByPersona;
